import React from 'react';
import { PageToolbarProps } from './types';
import { ToolbarIconButton } from './ToolbarIconButton';
import { translate } from 'javascripts/translations/i18n';

export type TableMenuProps = {
  editor: PageToolbarProps['editor'];
  disabled?: boolean;
};

export default function TableMenu(props: TableMenuProps) {
  const { editor, disabled } = props;

  const insertTable = () =>
    editor
      .chain()
      .focus()
      .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
      .run();

  return (
    <ToolbarIconButton
      disabled={disabled || !editor.can().insertTable()}
      icon="table-plus"
      accessibilityLabel={translate('pages.toolbar.addTable')}
      onClick={insertTable}
    />
  );
}
